var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  __indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

define(['jquery', 'app-common/view/base'], function($, BaseView) {
  var ToolbarView;
  return ToolbarView = (function(_super) {

    __extends(ToolbarView, _super);

    function ToolbarView() {
      ToolbarView.__super__.constructor.apply(this, arguments);
    }

    ToolbarView.prototype.initialize = function(options, params) {
      ToolbarView.__super__.initialize.apply(this, arguments);
      return this.settings = {
        type: this.pageId,
        features: options.features || [],
        attachedFeatures: options.attachedFeatures || []
      };
    };

    ToolbarView.prototype.showAllFeatures = function() {
      return this.showFeatures(this.settings.features);
    };

    ToolbarView.prototype.remove = function() {
      ToolbarView.__super__.remove.apply(this, arguments);
      return $('body').off('click.hide-feature');
    };

    ToolbarView.prototype.initFeatureAnimation = function(feature) {
      var element, hideHandler, showHandler;
      element = this.getFeatureElement(feature);
      showHandler = function() {
        return element.addClass('hovered');
      };
      hideHandler = function() {
        return element.removeClass('hovered');
      };
      element.hover(showHandler, hideHandler);
      if (__indexOf.call(this.settings.attachedFeatures, feature) >= 0) {
        element.on('click', function() {
          return element.addClass('active');
        });
        return $('body').on('click.hide-feature', function(e) {
          if (element[0] !== e.target && !element.has(e.target).length) {
            return element.removeClass('active');
          }
        });
      }
    };

    /*
    # @return {string} The ID of current widget
    */


    ToolbarView.prototype.getType = function() {
      return this.settings.type;
    };

    /*
    # @param {string} type ID for verifying
    # @return {boolean} Has current widget specified ID?
    */


    ToolbarView.prototype.hasType = function(type) {
      return type === this.settings.type;
    };

    /*
    # @param {string} feature name of the feature
    # @return {boolean} Has current widget specified feature?
    */


    ToolbarView.prototype.hasFeature = function(feature) {
      return __indexOf.call(this.settings.features, feature) >= 0;
    };

    /*
    # @param {string} feature name of the feature
    */


    ToolbarView.prototype.showFeature = function(feature) {
      this.getFeatureElement(feature).show();
      return this.initFeatureAnimation(feature);
    };

    /*
    # @param {Array} array of feature names
    */


    ToolbarView.prototype.showFeatures = function(features) {
      var feature, _i, _len, _results;
      _results = [];
      for (_i = 0, _len = features.length; _i < _len; _i++) {
        feature = features[_i];
        _results.push(this.showFeature(feature));
      }
      return _results;
    };

    /*
    # @param {string} feature name of the feature
    */


    ToolbarView.prototype.hideFeature = function(feature) {
      return this.getFeatureElement(feature).hide();
    };

    ToolbarView.prototype.getFeatureElement = function(feature) {
      return $("." + feature + "-feature");
    };

    ToolbarView.prototype.featureOn = function(feature) {
      return this.getFeatureElement(feature).addClass('active');
    };

    ToolbarView.prototype.featureOff = function(feature) {
      return this.getFeatureElement(feature).removeClass('active hovered');
    };

    return ToolbarView;

  })(BaseView);
});
